import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

async function fetchBikeInfo(url) {
  const response = await fetch(url)
  return await response.json()
}

const stationsUrl =
  'https://gbfs.urbansharing.com/oslobysykkel.no/station_information.json'
const statusUrl =
  'https://gbfs.urbansharing.com/oslobysykkel.no/station_status.json'

export default new Vuex.Store({
  state: {
    ready: false,
    stations: [],
  },
  mutations: {
    FETCH_STATIONS(state, items) {
      state.stations = items
      state.ready = true
    },
  },
  actions: {
    async fetchStations({ commit }) {
      const stations = await fetchBikeInfo(stationsUrl).then(
        result => result.data.stations
      )
      const statuses = await fetchBikeInfo(statusUrl).then(
        result => result.data.stations
      )
      const stationsWithStatus = []
      for (let i = 0; i < stations.length; i++) {
        stationsWithStatus.push({
          ...stations[i],
          ...statuses.find(item => item.station_id === stations[i].station_id),
        })
      }
      commit('FETCH_STATIONS', stationsWithStatus)
    },
  },
})
